<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">COMPANY CONFIGURATION</h1>
			<button type="button" class="btn btn-bertazzoni black rounded-0 mt-3" (click)="nuovaCompany()">NEW COMPANY</button>
		</div>

		<div class="row">
			<div class="col-12">
				<!--LASCIARE ORDINAMENTO SOLO SU COLONNA CLIENTE AS400, LE SELECT DELLE ALTRE DUE COLONNE PARTONO DISABILITATE E IL BTN SALVA NASCOSTO. SI ATTIVA TUTTO AL CLICK SULLA MODIFICA-->
				<table datatable [dtTrigger]="dtTrigger" class="row-border hover">
					<thead>
						<tr>
							<th>Codice</th>
							<th>Tipo Ordine</th>
							<th>Description</th>
							<th>Connector</th>
							<th></th>
						</tr>
					</thead>
					<tbody *ngIf="listaCompany.length > 0">
						<tr *ngFor="let company of listaCompany">
							<td>
								<input
									type="text"
									class="rounded-0 w-100 form-bertazzoni white"
									[disabled]="!company.feEdit"
									name="descrizione"
									[(ngModel)]="company.jsonIn.codice"
									[value]="company.codice" />
							</td>
							<td>
								<input
									type="text"
									class="rounded-0 w-100 form-bertazzoni white"
									[disabled]="!company.feEdit"
									name="descrizione"
									[(ngModel)]="company.jsonIn.tipoOrdine"
									[value]="company.tipoOrdine" />
							</td>
							<td>
								<input
									type="text"
									class="rounded-0 w-100 form-bertazzoni white"
									[disabled]="!company.feEdit"
									name="descrizione"
									[(ngModel)]="company.jsonIn.descrizione"
									[value]="company.descrizione" />
							</td>
							<td>
								<select
									class="minimal rounded-0 border-black"
									[disabled]="!company.feEdit"
									name="connettore"
									[(ngModel)]="company.jsonIn.connettore">
									<option [value]="null">SELECT</option>
									<option value="AS400">AS400</option>
									<option value="SAGEX3">SageX3</option>
								</select>
							</td>
							<td>
								<button type="button" class="btn btn-bertazzoni black rounded-0" *ngIf="company.feEdit" (click)="salva(company)">SA</button>
								<img
									src="assets/img/pencil.svg"
									class="action-icon"
									*ngIf="!company.feEdit"
									alt="update"
									(click)="company.feEdit = !company.feEdit" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
